import React, { useRef } from "react"; // Import useRef
import StatusDropdown, { recruitStatus } from "../../Dropdowns/StatusDropdown";

const InformationTabContent = ({
  initialData,
  status,
  handleStatusChange,
  ndaDate,
  setNdaDate,
  showStatus,
  setShowStatus,
}) => {
  const data = initialData || {}; // Ensure data is an object
  const statusButtonRef = useRef(null); // Create a ref for the status button

  return (
    <div className="grid grid-cols-2 gap-6">
      <div className="space-y-5">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Статус
          </label>
          <button
            ref={statusButtonRef} // Assign the ref to the button
            onClick={() => setShowStatus(!showStatus)}
            className="w-full text-left p-2 border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          >
            {recruitStatus[status] || "Выберите статус"}
          </button>
          {showStatus && (
            <StatusDropdown
              targetRef={statusButtonRef} // Pass the button ref
              onChange={handleStatusChange}
              onClose={() => setShowStatus(false)} // Pass an onClose handler
            />
          )}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Имя*
          </label>
          <input
            type="text"
            name="first_name"
            defaultValue={data.first_name || ""}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Фамилия*
          </label>
          <input
            type="text"
            name="last_name"
            defaultValue={data.last_name || ""}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Телефон
          </label>
          <input
            type="tel"
            name="phone_number"
            defaultValue={data.phone_number || ""}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          />
        </div>
      </div>

      <div className="space-y-5">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <input
            type="email"
            name="email"
            defaultValue={data.email || ""}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            LinkedIn
          </label>
          <input
            type="url"
            name="linkedin"
            defaultValue={data.linkedin || ""}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            FB/IG
          </label>
          <input
            type="text"
            name="FB_IG"
            defaultValue={data.FB_IG || ""}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            NDA Подписан
          </label>
          <select
            name="NDA_date"
            value={ndaDate}
            onChange={(e) => setNdaDate(e.target.value)}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          >
            <option value="No">Нет</option>
            <option value="Yes">Да</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default InformationTabContent;